import { DEFAULT_VOXEL_MATERIAL, type VoxelData, type VoxelMap } from '@/voxelTypes'
import { canonicalVoxelType } from '@/voxels/registry'
import {
  BLOB_MOLTEN_SILVER_COLOR,
  BLOB_MOLTEN_SILVER_MATERIAL,
} from '@/voxels/blob_sdf/constants'
import { TINT_DEFAULT_COLOR } from '@/voxels/tint/tintConstants'

export function getItemColor(item: VoxelData): number {
  switch (canonicalVoxelType(item.type)) {
    case 'solid': return item.color ?? 0xffffff
    case 'googly_eye': return 0xffffff
    case 'ice_cube': return item.color ?? 0x00e6ff
    case 'road': return item.color ?? 0xffcc33
    case 'tube': return item.color ?? 0xffd100
    case 'sphere': return item.color ?? 0xff66cc
    case 'diamond': return item.color ?? 0x00ffff
    case 'heart': return item.color ?? 0xff1493
    case 'tree': return item.color ?? 0x228b22
    case 'glass_cube': return item.color ?? 0x66ccff
    case 'water': return item.color ?? 0x3399ff
    case 'blob': return item.color ?? 0xb8ebff
    case 'cloud': return item.color ?? 0xf4fbff
    // Bulk materials (materials-perf-plan B1): warm beige, near-white, terracotta.
    case 'sand': return item.color ?? 0xe6cfa0
    case 'clay': return item.color ?? 0xc0623a
    case 'tint': return item.color ?? TINT_DEFAULT_COLOR
    default: return item.color ?? 0xffffff
  }
}

export function defaultPaletteItems(): VoxelData[] {
  return [
    { type: 'solid', color: 0xd92626 },
    { type: 'blob', color: 0xb8ebff, material: DEFAULT_VOXEL_MATERIAL },
    { type: 'cloud', color: 0xf4fbff },
    { type: 'blob', color: BLOB_MOLTEN_SILVER_COLOR, material: BLOB_MOLTEN_SILVER_MATERIAL },
    { type: 'googly_eye' },
    { type: 'glass_cube', color: 0x66ccff },
    { type: 'tube', color: 0xffd100 },
    { type: 'sphere', color: 0xff66cc },
  ]
}

function paletteKey(item: VoxelData): string {
  return `${item.type}:${item.color ?? ''}:${item.material ?? ''}:${item.density ?? ''}`
}

export function inferPaletteFromBase(base: VoxelMap): VoxelData[] {
  const seen = new Map<string, VoxelData>()
  for (const [, v] of base as VoxelMap) {
    const item: VoxelData = { type: canonicalVoxelType(v.type) }
    if (typeof v.color === 'number') item.color = v.color
    if (v.material) item.material = v.material
    if (v.density !== undefined) item.density = v.density
    const key = paletteKey(item)
    if (!seen.has(key)) seen.set(key, item)
  }
  
  // const allTypes: VoxelData['type'][] = [
  //   'solid', 'googly_eye', 'ice_cube', 'road', 'tube', 
  //   'sphere', 'diamond', 'heart', 'tree', 'glass_cube', 'water'
  // ]
  
  // const seenTypes = new Set(
  //   Array.from(seen.keys()).map(k => k.split(':')[0])
  // )
  
  const items = Array.from(seen.values())
  
  // for (const type of allTypes) {
  //   if (!seenTypes.has(type)) {
  //     const hue = Math.floor(Math.random() * 360)
  //     const color = hslToHex(hue, 70, 50)
  //     items.push({ type, color } as VoxelData)
  //   }
  // }
  
  return items
}
